import React from "react";
import {BooleanRadioButton, BooleanRadioButtonGroup} from "@octopusdeploy/design-system-components";
import {DataBaseComponent, DataBaseComponentState, Errors} from "../../../components/DataBaseComponent";
import {BusyState} from "../../../components/BusyFromPromise/BusyFromPromise";
import {HostedInstanceResource} from "../../../client/resources/hostedInstanceResource";
import SaveDialogLayout from "../../../components/DialogLayout/SaveDialogLayout";
import repository from "../../../client/repository";
import {HostedInstanceRotateSqlLoginsRequest} from "../../../client/resources/HostedInstanceRotateSqlLoginsRequest";
import { Callout } from "@octopusdeploy/design-system-components";

interface Props {
    errors: Errors;
    busy: BusyState;
    instance: HostedInstanceResource;
    onSaveClick(): Promise<boolean>;
}

interface State extends DataBaseComponentState {
    rotateSqlLoginsRequest: Partial<HostedInstanceRotateSqlLoginsRequest>;
}


export class RotateSqlLoginsDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            rotateSqlLoginsRequest: {
                ApplyDuringMaintenanceWindow: true
            }
        };
    }

    render() {
        const request = this.state.rotateSqlLoginsRequest;
        return <SaveDialogLayout title={"Rotate SQL Usernames and Passwords"}
                                 errors={this.state.errors}
                                 busy={this.state.busy}
                                 onSaveClick={() => this.rotateSqlLogins(request)}>

            <Callout type="information" title="User rotation">
                New logins will be created immediately and existing logins will remain active until after the Instance has been reprovisioned with the new credentials.
            </Callout>

            <BooleanRadioButtonGroup value={this.state.rotateSqlLoginsRequest.ApplyDuringMaintenanceWindow}
                              onChange={ApplyDuringOutage => this.updateRotateSqlLoginsRequest({ApplyDuringMaintenanceWindow: ApplyDuringOutage})}>
                <BooleanRadioButton value={true} label="Apply During Outage Window"/>
                <BooleanRadioButton value={false} label="Apply Immediately"/>
            </BooleanRadioButtonGroup>
        </SaveDialogLayout>;
    }

    private updateRotateSqlLoginsRequest(update: Partial<HostedInstanceRotateSqlLoginsRequest>) {
        return this.setState(prevState => ({rotateSqlLoginsRequest: {...prevState.rotateSqlLoginsRequest, ...update}}));
    }

    private async rotateSqlLogins(request: Partial<HostedInstanceRotateSqlLoginsRequest>) {
        return await this.doBusyTask(async () => {
            await repository.HostedInstances.rotateSqlLogins(this.props.instance, request as HostedInstanceRotateSqlLoginsRequest);
            await this.props.onSaveClick();
            return true;
        });
    }
}
